import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=b6463c38&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=ts&"
export * from "./statistics.vue?vue&type=script&lang=ts&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=b6463c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6463c38",
  null
  
)

export default component.exports